module.exports = Promise.resolve(module.bundle.root("7hyVa"))